/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum AgentTaskStatus {
  Running = "running",
  Completed = "completed",
  Failed = "failed",
  TimedOut = "timed_out",
}

export function instanceOfAgentTaskStatus(value: any): boolean {
  for (const key in AgentTaskStatus) {
    if (Object.prototype.hasOwnProperty.call(AgentTaskStatus, key)) {
      if (AgentTaskStatus[key as keyof typeof AgentTaskStatus] === value) {
        return true;
      }
    }
  }
  return false;
}

export function AgentTaskStatusFromJSON(json: any): AgentTaskStatus {
  return AgentTaskStatusFromJSONTyped(json, false);
}

export function AgentTaskStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AgentTaskStatus {
  return json as AgentTaskStatus;
}

export function AgentTaskStatusToJSON(value?: AgentTaskStatus | null): any {
  return value as any;
}

export function AgentTaskStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AgentTaskStatus {
  return value as AgentTaskStatus;
}
